import React, { useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../assets/rs-logo.png";

const FlagCounter = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <div
      style={{
        minHeight: "100px",
        display: "flex",
        alignItems: "center",
      }}
    >
      {loading && !error && (
        <span style={{ color: "#ccc", fontSize: "14px" }}>
          Loading visitor map...
        </span>
      )}
      {error && (
        <span style={{ color: "red", fontSize: "14px" }}>
          Failed to load visitor map.
        </span>
      )}
      <a
        href="https://info.flagcounter.com/mJNS"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://s01.flagcounter.com/map/mJNS/size_s/txt_000000/border_CCCCCC/pageviews_0/viewers_0/flags_0/"
          alt="Flag Counter"
          style={{
            display: loading || error ? "none" : "block",
            maxWidth: "100%",
            height: "auto",
          }}
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
      </a>
    </div>
  );
};
const Footer = () => {
  return (
    <footer className="far-footer text-light py-10" style={{}}>
      <div>
        <Row className="g-8">
          <Col xs={12} lg={1}></Col>
          <Col xs={12} md={12} lg={4}>
            <div>
              <div className="footer-logo">
                <img
                  src={logo}
                  alt="RUISI-GLOBAL Publishing Logo"
                  className="img-fluid"
                  style={{ maxHeight: "60px" }}
                />
              </div>
            </div>

            <p
              className="text-gray-300 leading-relaxed"
              style={{
                textAlign: "justify",
              }}
            >
              RUISI Global was established in 2025 as an open access academic
              publishing platform registered in Hong Kong, dedicated to
              integrating global academic resources through digital innovation.
              With a vision of “Connecting Research, Inspiring Innovation,”
              Ruisiglobal focuses on publishing high-quality journals across the
              fields of science, technology, and medicine. By leveraging
              advanced internet technologies and data-driven publishing models,
              Ruisiglobal aims to accelerate the dissemination of scientific
              knowledge and promote international academic collaboration. The
              company actively cooperates with global publishers, universities,
              and research societies to advance open access and build a
              transparent, efficient, and inclusive academic ecosystem.
            </p>
          </Col>
          <Col xs={12} lg={2}></Col>
          <Col xs={12} md={12} lg={3}>
            <h3
              className="text-white p-0 m-0"
              style={{ height: "60px", lineHeight: "60px" }}
            >
              Record Visitors
            </h3>
            <Row className="g-2">
              <FlagCounter />
            </Row>
          </Col>
          <Col xs={12} lg={1}></Col>
        </Row>

        <hr className="footer-divider border-gray-700 mb-6" />

        <div className="copyright text-center text-gray-400 text-sm">
          © {new Date().getFullYear()} RUISI-GLOBAL Publishing Limited. All
          rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
